export default __webpack_public_path__ + "static/carousel_image_4_uta-374a3abdba7fa62f6a4a6c751537647f.jpg";